import { connect } from "react-redux";
import { NavLink as Link } from "react-router-dom";
import {
  BarChartOutlined,
  CheckCircleOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FacebookOutlined,
  FormOutlined,
  GiftOutlined,
  InfoCircleOutlined,
  LikeOutlined,
  MailOutlined,
  ShopOutlined,
  ShareAltOutlined,
  SmileOutlined,
  TeamOutlined,
  TrophyOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { SideMenu } from "../../../constants/data";
import styles from "./sidebar.module.scss";

// Team members only ever see the 5 phase-1 screens they have permission
// for; parent/owner accounts (myTeamPermissions.is_team_member: false,
// or not yet loaded) see everything, unchanged.
const getVisibleMenu = (myTeamPermissions, user, sidebarTabs) => {
  const permittedMenu = SideMenu.filter(
    (menu) =>
      (!menu.superuserOnly || !!(user && user.is_superuser)) &&
      (!menu.staffOnly || !!(user && user.is_staff))
  );
  const clientMenu = Array.isArray(sidebarTabs)
    ? permittedMenu.filter((menu) => sidebarTabs.includes(menu.sidebarKey))
    : permittedMenu;
  const isRestrictedTeamMember = !!(myTeamPermissions && myTeamPermissions.is_team_member);
  if (!isRestrictedTeamMember) {
    return clientMenu;
  }

  const permissions = myTeamPermissions.permissions || {};
  return clientMenu.filter(
    (menu) => menu.requiredPermission && permissions[menu.requiredPermission]
  );
};

const ICONS = {
  dashboard: DashboardOutlined,
  team: TeamOutlined,
  form: FormOutlined,
  smile: SmileOutlined,
  "customer-service": CustomerServiceOutlined,
  trophy: TrophyOutlined,
  "check-circle": CheckCircleOutlined,
  user: UserOutlined,
  mail: MailOutlined,
  shop: ShopOutlined,
  file_done: FileDoneOutlined,
  "bar-chart": BarChartOutlined,
  gift: GiftOutlined,
  share_alt: ShareAltOutlined,
  dollar: DollarOutlined,
  like: LikeOutlined,
  info: InfoCircleOutlined,
  upload: UploadOutlined,
  facebook: FacebookOutlined,
};

const MenuIcon = ({ type }) => {
  const IconComponent = ICONS[type] || InfoCircleOutlined;
  return <IconComponent />;
};

function SidebarMenu({
    theme,
    myTeamPermissions,
    user,
    storeConfig,
}) {
  const visibleMenu = getVisibleMenu(
    myTeamPermissions,
    user,
    storeConfig && storeConfig.sidebar_tabs
  );

  return (
    <Menu
      theme={theme}
      mode="inline"
      style={{
        marginTop: "4rem",
        height: "auto",
        background: "rgba(215,215,215,0.1)",
      }}
    >
      {visibleMenu.map((menu) => {
        return (
          <Menu.Item
            key={menu.key}
            className={
              window.location.pathname === menu.link
                ? "ant-menu-item-selected"
                : ""
            }
          >
            {menu.external ? (
              <a href={menu.link}>
                <MenuIcon type={menu.icon} />
                <span className={styles.menu_text}>{menu.name}</span>
              </a>
            ) : (
              <Link to={menu.link}>
                <MenuIcon type={menu.icon} />
                <span className={styles.menu_text}>{menu.name}</span>
              </Link>
            )}
          </Menu.Item>
        );
      })}
    </Menu>
  );
}

const mapStateToProps = (state) => ({
  myTeamPermissions: state.teamMembers.myPermissions,
  user: state.auth.user,
  storeConfig: state.auth.storeConfig,
});

export default connect(mapStateToProps)(SidebarMenu);
